/* @flow */
import PaymentAccountActions from 'payments/actions/PaymentAccountActions';
import PaymentAccountStore from 'payments/stores/PaymentAccountStore';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

const RequirePaymentAccount = {
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
      if (PaymentAccountStore.getPaymentAccount()) {
        callback();
      } else {
        PaymentAccountActions.load().then(() => callback());
      }
    },
  },
};

export default RequirePaymentAccount;



// WEBPACK FOOTER //
// ./src/components/mixins/RequirePaymentAccount.js